import { render, staticRenderFns } from "./CreateConsignmentNew.vue?vue&type=template&id=bc7345ae"
import script from "./CreateConsignmentNew.vue?vue&type=script&lang=js"
export * from "./CreateConsignmentNew.vue?vue&type=script&lang=js"
import style0 from "./CreateConsignmentNew.vue?vue&type=style&index=0&id=bc7345ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports